import React from 'react';

import Base from './Base.jsx';

import EditAccount from '../Components/EditAccount/index.jsx';


class EntryPoint extends Base {
  id() {
    return 'cs-myaccount-edit';
  }

  renderElement(element) {
    var nonce = element.dataset.nonce;

    return (
      <EditAccount nonce={nonce} />
    );
  }
}


export default EntryPoint;

